import { Alert, CircularProgress, Stack } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import TierBandsEditor from '../../features/tier-bands/TierBandsEditor'
import { useTierBands } from '../../features/tier-bands/useTierBands'
import type { AvatarBoClient } from '../../shared/types'

export default function TierBandsScreen({ client }: { client: AvatarBoClient }) {
  const { formatMessage } = useIntl()
  const { query, save, apiError } = useTierBands(client)

  if (query.isLoading) {
    return (
      <Stack alignItems="flex-start" sx={{ p: 2 }}>
        <CircularProgress size={24} />
      </Stack>
    )
  }

  if (query.isError || !query.data) {
    return (
      <Alert severity="error">{formatMessage({ id: 'avatarStudio.tiers.loadFailed' })}</Alert>
    )
  }

  return (
    <TierBandsEditor
      key={query.data.bands.join('|')}
      bands={query.data.bands}
      isDefault={query.data.isDefault}
      saving={save.isLoading}
      apiError={apiError}
      // tslint:disable-next-line: jsx-no-lambda
      onSave={(bands) => save.mutate(bands)}
    />
  )
}
